import { AxiosError } from 'axios'

export const isError = (error: unknown): error is AxiosError => !!(error as AxiosError)?.isAxiosError
